module.exports = {"development":{"host":"localhost:4567","protocol":"http","webSocketProtocol":"ws"},"production":{"host":"frontiersmen.herokuapp.com","protocol":"https","webSocketProtocol":"wss"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 172
// module chunks = 0